import { ReactElement } from 'react';
import classnames from 'classnames';
import { Trans, useTranslation } from 'next-i18next';
import { useWindowSize } from '@Hotels-at-Home/hah-fe-core/dist/hooks';
import classNames from 'classnames';

interface ServiceItem {
  id: number;
  icon: string;
  translationKey: string;
  className?: string;
}

interface ServicesProps {
  items: ServiceItem[];
  border?: boolean;
  mainSection?: boolean;
}

const Services = ({ items, border = true, mainSection = false }: ServicesProps): ReactElement => {
  const { t: tTitle, ready } = useTranslation('', { keyPrefix: '$local.$services.$titles' });
  const { t: tDescription } = useTranslation('', { keyPrefix: '$local.$services.$descriptions' });

  if (!ready) {
    return null;
  }

  return (
    <section
      className={classnames(
        'services',
        mainSection ? 'content-services' : 'hp-content-wrapper',
        !border && 'no-border',
      )}
    >
      <ul>
        {items.map(({ id, icon, translationKey, className }) => (
          <li key={id} className={classNames('services-service', className)}>
            <i className={classnames('services-service-icon', icon)} />
            <div className="services-service-copy">
              <p className="services-service-title">
                <Trans
                  i18nKey={translationKey}
                  t={tTitle}
                  components={{
                    sup: <sup />,
                  }}
                />
              </p>
              <p className="services-service-description">
                <Trans
                  i18nKey={translationKey}
                  t={tDescription}
                  components={{
                    sup: <sup />,
                  }}
                />
              </p>
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default Services;
